// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__262vZ","content":"styles_content__2io5J"};